import { BELENUS } from '../../../../../packages/contracts/src/mocks/belenus.js';
import type { DonneesArbre, Relation } from './types.js';

/**
 * Famille Bélénus des maquettes (données entièrement fictives), servie tant que l'écran tourne sur les mocks du contrat
 * (mode « Données d'exemple », UX-08). Profession et situation viennent des maquettes D04 : le contrat ne les porte pas.
 */
export function donneesExemple(): DonneesArbre {
  const { ids } = BELENUS;
  const relations: Relation[] = BELENUS.relations.map(([a, b, kind], i) => ({
    id: `0192a6c0-0000-7000-8000-${(0xb00 + i).toString(16).padStart(12, '0')}`,
    kind,
    personAId: a,
    personBId: b,
    unionType: kind === 'union' ? 'mariage' : null,
    filiationType: kind === 'filiation' ? 'biologique' : null,
    startDate: null,
    endDate: null,
  }));
  return {
    personnes: BELENUS.personnes,
    relations,
    successions: BELENUS.successions,
    devolution: BELENUS.devolution,
    residences: { [ids.filleLucien]: { pays: 'JP', certitude: 'hypothese' } },
    complements: {
      [ids.josiane]: { profession: 'retraitée', situation: 'veuve' },
      [ids.marc]: { profession: 'technicien', situation: 'marié' },
      [ids.sandra]: { profession: 'infirmière', situation: 'célibataire' },
    },
  };
}

/** Personne qui consulte l'arbre client en mode exemple : Marc, héritier de la branche de Marie. */
export const HERITIER_EXEMPLE = BELENUS.ids.marc;
